import { ref, defineComponent, watch, computed, onMounted, nextTick } from 'vue'
import { MdTypography, MdIconClose, MdButton } from '@antiqua-dls/vue-components'
import { useStore } from 'vuex'
import i18n from 'src/assets/i18n/i18n'
const { t } = i18n().global

export default defineComponent({
  name: 'Foupills',

  components: {
    MdTypography,
    MdIconClose,
    MdButton
  },
  props: {
    foundries: {
      type: Array
    },
    showClearAll: { 
      type: Boolean, 
      default: true 
    },
    pillInSis: {
      type: Boolean,
      default: false
    },
    arrayOfWarningWords : {
      type: Array,
      default: []
    },
    verticalScroll: {
      type: Boolean,
      default: false
    },
    removeTagsForSis: {
      type: Boolean,
      default: false
    },
    inheritedContainerHeight:{
      type: Number,
      default: 152
    },
    showMaxTagsWarning: {
      type: Boolean,
      default: false
    },
    maximumTagCount: {
      type: Number,
      default: 20
    },
    removeOnClick: {
      type: Boolean,
      default: true
    },
    showTagsCount: {
      type: Boolean,
      default: true
    },
    clearAllText: {
      type: String,
      default: t('pages.submissions.components.descriptions.tags.remove_all')
    }
  },
  emits: ['foundryRemoved', 'removeAll'],
  setup(props, { emit }) {
    const store = useStore()
    const foundriesCopy = ref([...props.foundries])
    const deleteUrl = ref(require('../asset/Cross.svg').default)
    const scrollLeftButton = ref(require('../asset/ScrollLeft.svg').default)
    const scrollRightButton = ref(require('../asset/ScrollRight.svg').default)
    const shouldShowScrollLeftButton = ref(false)
    const shouldShowScrollRightButton = ref(false)
    const navBarState = computed(() => store?.getters['sideNavigation/getNavBarState'])

    watch(
      () => props.foundries,
      newVal => {
        foundriesCopy.value = [...newVal]
        requestAnimationFrame(() => {
          handleScroll();
        })
      },
      { deep: true, immediate: true }
    )

    watch(
      () => navBarState.value,
      newVal => {
        requestAnimationFrame(() => {
          handleScroll();
        })
      }
    )

    const foundryContainer = ref(null)
    const containerHeight = ref(0)
    const handleScroll = () => {
      if (foundryContainer.value) {
        if(props.verticalScroll) {
          setTimeout(() => {
            updateContainerHeight()
          }, 0);
        }
        nextTick(() => {
          setTimeout(() => {
            const isAtStart = foundryContainer.value?.scrollLeft;
            let containerWidth = foundryContainer.value?.clientWidth;
            const contentWidth = foundryContainer.value?.scrollWidth;
            shouldShowScrollLeftButton.value = isAtStart > 0;
            shouldShowScrollRightButton.value = (isAtStart + containerWidth + 30) < contentWidth;
          }, 300)
       })
      }
    };

    const updateContainerHeight = () => {
      containerHeight.value = foundryContainer.value?.clientHeight;
    }
    const scrollLeft = () => {
      if (foundryContainer.value) {
        foundryContainer.value.scrollTo({
          left: foundryContainer.value.scrollLeft - 300,
          behavior: 'smooth'
        })
      }
    }

    const scrollRight = () => {
      if (foundryContainer.value) {
        foundryContainer.value.scrollTo({
          left: foundryContainer.value.scrollLeft + 300,
          behavior: 'smooth'
        })
      }
    }

    const checkForWarningWords = (tagName) => {
      if (props.arrayOfWarningWords.length === 0) return
      const warningWordsArray = Object.values(props.arrayOfWarningWords).map(word => word.toLowerCase());
      return warningWordsArray.includes(tagName?.toLowerCase());
    }

    const removeFoundry = foundry => {
      if (!props.removeOnClick) {
        emit('foundryRemoved', foundry)
        return;
      }
      const index = foundriesCopy.value.findIndex(item => item.value === foundry.value)
      if (index !== -1) {
        foundriesCopy.value.splice(index, 1)
      }
      emit('foundryRemoved', foundry)
    }

    const removeAll = () => {
      if (!props.removeOnClick) {
        emit('removeAll')
        return;
      }
      foundriesCopy.value.splice(0, foundriesCopy.value.length)
      emit('removeAll', foundriesCopy.value)
    }

    onMounted(() => {
      handleScroll()
    })

    return {
      navBarState,
      foundriesCopy,
      removeFoundry,
      removeAll,
      deleteUrl,
      scrollLeft,
      foundryContainer,
      scrollRight,
      scrollLeftButton,
      scrollRightButton,
      shouldShowScrollLeftButton,
      shouldShowScrollRightButton,
      handleScroll,
      containerHeight,
      checkForWarningWords,
    }
  }
})